export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string,
    public readonly payload?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export class ValidationError extends ApiError {
  constructor(
    message: string,
    public readonly errors: Record<string, string[]>,
    payload?: unknown,
  ) {
    super(message, 422, "VALIDATION_FAILED", payload);
    this.name = "ValidationError";
  }
}

export class AuthError extends ApiError {
  constructor(message = "You must be signed in.", payload?: unknown) {
    super(message, 401, "UNAUTHENTICATED", payload);
    this.name = "AuthError";
  }
}

export class ForbiddenError extends ApiError {
  constructor(message = "You do not have permission to perform this action.", payload?: unknown) {
    super(message, 403, "FORBIDDEN", payload);
    this.name = "ForbiddenError";
  }
}

export class NetworkError extends ApiError {
  constructor(message = "Network request failed.") {
    super(message, 0, "NETWORK_ERROR");
    this.name = "NetworkError";
  }
}
